import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { useClerk } from '@clerk/clerk-react';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const { openSignUp } = useClerk();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleComecarAgora = () => {
    if (isAuthenticated) {
      navigate('/dashboard');
    } else {
      openSignUp();
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0E27]">
      <Header />
      
      <main className="pt-20">
        <section className="container mx-auto px-6 py-20 text-center">
          <div className="inline-block px-4 py-2 bg-[#1A1F3A] rounded-full text-sm text-gray-300 mb-6">
            Análise Inteligente de Vídeos
          </div>
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Analise Vídeos do YouTube com{' '}
            <span className="gradient-text">Inteligência Artificial</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto mb-8">
            Identifique erros, exageros, manipulações e conteúdos sensacionalistas em vídeos do YouTube. 
            Análise imparcial baseada em evidências e fontes confiáveis.
          </p>
          <div className="flex items-center justify-center">
            <Button size="lg" onClick={handleComecarAgora}>
              Começar Agora
            </Button>
          </div>
        </section>

        <section className="container mx-auto px-6 py-20">
          <h2 className="text-4xl font-bold text-center mb-12">
            Por que usar nossa plataforma?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                icon: '🔍',
                title: 'Análise Imparcial',
                description: 'Identifique erros e manipulações com base em evidências e fontes confiáveis'
              },
              {
                icon: '⚡',
                title: 'Rápido e Eficiente',
                description: 'Obtenha análises completas em minutos, não horas'
              },
              {
                icon: '🛡️',
                title: 'Detecção de Fake News',
                description: 'Identifique informações falsas e conteúdos sensacionalistas'
              }
            ].map((feature, index) => (
              <Card key={index} className="p-6" hover>
                <div className="text-4xl mb-4">{feature.icon}</div>
                <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
                <p className="text-gray-400">{feature.description}</p>
              </Card>
            ))}
          </div>
        </section>

        <section className="container mx-auto px-6 py-20">
          <h2 className="text-4xl font-bold text-center mb-12">
            Como Funciona
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { step: '01', title: 'Cole a URL', description: 'Insira o link do vídeo do YouTube que deseja analisar' },
              { step: '02', title: 'IA Analisa', description: 'Nossa inteligência artificial processa a transcrição e identifica problemas' },
              { step: '03', title: 'Receba Resultado', description: 'Obtenha uma análise completa e imparcial do conteúdo' }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="text-6xl font-bold text-gray-700 mb-4">{item.step}</div>
                <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                <p className="text-gray-400">{item.description}</p>
              </div>
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

